import { cspRules } from './constants';

/* CSP
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy
 * default-src fallback: child-src, connect-src, font-src, frame-src, img-src, manifest-src,
 *                       media-src, object-src, prefetch-src, script-src, script-src-elem,
 *                       script-src-attr, style-src, style-src-elem, style-src-attr, worker-src
 * Note: script-src is defined additionally below for visibility/emphasis even though it falls back
 *       to default-src (see above)
 * This CSP provides a baseline for previewing member-generated content. Deny everything except:
 *   - fonts (allow any)
 *   - images (allow any, even data urls)
 *     https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 *   - style (unsafe-inline is necessary for styling email content) */

export const HeadCSP = () => {
  return <meta httpEquiv="Content-Security-Policy" content={cspRules.join('; ')} />;
};

export default HeadCSP;
